import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";

export const MultiQuestion = observer((props) => {
    const {question, numberOptions, checkbox} = props;

    let limitMessage = "Choose as many as you like.";
    if (question.limit) {
        limitMessage = `Choose up to ${question.limit}.`;
    }
    if (!checkbox) {
        limitMessage = '';
    }

    const items = () => {
        return (<Fragment>
            {question.options.map((option, i) =>
                <li key={"items-option-" + i}>
                    <label>
                        <input
                            type={(checkbox) ? "checkbox" : "radio"}
                            name={'radio'}
                            checked={option.selected}
                            onChange={option.toggleSelected}/>
                        {option.text}
                    </label>
                    {question.other && i === question.options.length - 1 && question.options[question.options.length - 1].selected &&
                    <input
                        type="text"
                        onBlur={(e) => question.setOtherText(e.target.value)}
                    />
                    }
                </li>
            )}


        </Fragment>);
    };

    return (<form>
        <h3>{question.question}</h3>
        <p>{limitMessage}</p>
        {numberOptions && <ol>{items()}</ol>}
        {!numberOptions && <ul style={{'listStyleType': 'none'}}>{items()}</ul>}
    </form>);
});
MultiQuestion.defaultProps = {
    checkbox: true,
    numberOptions: true,
};

const RadioQuestion = observer((props) => {
    const {question, numberOptions, checkbox} = props;

    const items = () => {
        return (<Fragment>
            {question.options.map((option, i) =>
                <li key={"radio-option-" + i}>
                    <label>
                        <input
                            type={(checkbox) ? "checkbox" : "radio"}
                            name={'radio'}
                            checked={option.selected}
                            onChange={option.toggleSelected}/>
                        {option.text}
                    </label>
                    {question.other && i === question.options.length - 1 && question.options[question.options.length - 1].selected &&
                    <input
                        type="text"
                        onBlur={(e) => question.setOtherText(e.target.value)}
                    />
                    }
                </li>
            )}


        </Fragment>);
    };

    return (<form>
        <h3>{question.question}</h3>
        {numberOptions && <ol>{items()}</ol>}
        {!numberOptions && <ul style={{'listStyleType': 'none'}}>{items()}</ul>}
    </form>);
});


const TextQuestion = observer((props) => {
    const {question, numberOptions, checkbox} = props;

    const items = () => {
        return (<Fragment>
            <label>
                <input
                    type="text"
                    onBlur={(e) => question.setOtherText(e.target.value)}
                />
            </label>

        </Fragment>);
    };

    return (<form>
        <h3>{question.question}</h3>
        {numberOptions && <ol>{items()}</ol>}
        {!numberOptions && <ul style={{'listStyleType': 'none'}}>{items()}</ul>}
    </form>);
});


const DropdownQuestion = observer((props) => {
    const {question, numberOptions, checkbox} = props;

    const items = () => {
        return (<Fragment>
            <option value={'_PROMPT_'}>-</option>
            {question.options.map((option, i) =>
                <option value={option.text}>
                  {option.text}
                </option>
            )}
        </Fragment>);
    };

    const handleChange = (e) => {
        const value = e.target.value;
        const answer = question.options.filter(option => option.text === value)[0];
        question.resetOptions();
        answer.toggleSelected();
    };

    return (<form>
        <h3>{question.question}</h3>
        <form>
          <select onChange={handleChange}>
            {items()}
          </select>
            {question.other && question.options[question.options.length - 1].selected &&
            <input
                type="text"
                onBlur={(e) => question.setOtherText(e.target.value)}
            />
            }
        </form>
    </form>);
});

function FormElement(props) {
    const {store, id} = props;
    const interactiveElements = store.persistStore.interactiveElements.get(id);
    if (!interactiveElements) return <Fragment/>
    return (
        <div className="FormElement">
            {interactiveElements.questions.map((question, i) => {
                if (question.type === "multi") {
                    if (question.audience.length > 0) {
                        if (question.audience.indexOf(store.persistStore.profile) > -1) {
                            return <MultiQuestion key={'questions' + i} question={question}/>
                        }
                    } else {
                        return <MultiQuestion key={'questions' + i} question={question}/>
                    }
                } else if (question.type === "radio") {
                    if (question.audience.length > 0) {
                        if (question.audience.indexOf(store.persistStore.profile) > -1) {
                            return <RadioQuestion key={'questions' + i} question={question}/>
                        }
                    } else {
                        return <RadioQuestion key={'questions' + i} question={question}/>
                    }
                } else if (question.type === "text") {
                    if (question.audience.length > 0) {
                        if (question.audience.indexOf(store.persistStore.profile) > -1) {
                            return <TextQuestion key={'questions' + i} question={question}/>
                        }
                    } else {
                        return <TextQuestion key={'questions' + i} question={question}/>
                    }
                } else if (question.type === "dropdown"){
                  if (question.audience.length > 0){
                      if (question.audience.indexOf(store.persistStore.profile) > -1){
                          return <DropdownQuestion key={'questions'+i} question={question} />
                      }
                  } else {
                      return <DropdownQuestion key={'questions'+i} question={question} />
                  }
                }
            })}
        </div>
    );
}

export default observer(FormElement);
